









import Vue from 'vue'

export default Vue.extend({
  props: {
    columns: {
      type: Array,
      default: () => ([])
    },
    dataValue: {
      type: Array,
      default: () => ([])
    },
    index: {
      type: Number,
      default: null
    },
  },
  data(){
    return {
      tableColumns: [],
      tableData: []
    }
  },
  mounted(){
    this.initTableColumns()
  },
  methods:{
    initTableColumns(){
      this.tableColumns = [{
        title: this.$t('page_operation_statistics_workstationname'),
        dataIndex: 'title',
        key: 'title',
        width: 100
      }]
      this.columns.forEach(item => {
        const value = {
          title: item.wcsName,
          dataIndex: item.wcsName,
          key: item.wcsName,
          width: 100
        }
        this.tableColumns.push(value)
      });
      this.initTableData()
    },
    initTableData(){
      this.tableData = []
      this.dataValue.forEach(item => {
        this.tableData.push({
          title: item.workStationName
        })
      })
      this.tableData.forEach(res => {
        this.dataValue.forEach(item => {
          this.columns.forEach(function(data){
            const key = data.wcsName
            if (item.workStationName === res.title) {
              res[key] = (item.wcsData[key] ? item.wcsData[key] : '0') + 'h'
            }
          })
        })
      })
    }
  }
})

